var exports = {
  "T": "x31de4314--6a96f1--map",
};

module.exports = exports;
